import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/pages/auth/interceptor/auth.interceptor';
import { IMAGE_CONFIG } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,

      ],
    providers: [provideHttpClient(),
      provideHttpClient(
        withInterceptorsFromDi(),
      ),
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true 
     
      },
      {
        provide: IMAGE_CONFIG,
        useValue: {
          disableImageSizeWarning: true,
          disableImageLazyLoadWarning: true
        }
      }
    ],
    
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
